'use client'
import { Box, Grid, Typography } from '@mui/material'
import { Strings } from '@/lib/constants/strings'
import React, { useEffect } from 'react'
import { TypographyVariants } from '@/app/styles/themes/typography'
import { useNavigation } from '@/lib/context/navigationcontext'
import { Button } from '@/lib/core-ui/button'
import { useUserContext } from '@/lib/context/userContext'
import Image from 'next/image'

export default function LoginView() {
	const { signin } = useUserContext()
	const { setShowLeftNav, setShowTopNav } = useNavigation()

	useEffect(() => {
		setShowLeftNav?.(false)
		setShowTopNav?.(false)
	})

	return (
		<Grid
			container
			justifyItems={'center'}
			justifyContent="center"
			alignItems="center"
			direction="column"
			alignSelf="center"
			minHeight={'100vh'}
		>
			<Box
				sx={{
					mx: 'auto',
					textAlign: 'center',
					bgcolor: theme => theme.palette.surface.neutral.t1Base,
					border: theme => `1px solid ${theme.palette.stroke.neutral.low}`,
					borderBottom: theme =>
						`1px solid ${theme.palette.stroke.neutral.low}`,
					borderRadius: '8px',
					p: { xs: '24px', sm: '36px' },
					pb: 4,
				}}
			>
				<Image
					src="/icons/bi_icons/broker-workplace.svg"
					alt="broker-workplace-icon"
					width={160}
					height={66}
					data-testid={'broker-workplace-icon'}
					aria-label={'broker-workplace-icon'}
					style={{ margin: 'auto', display: 'block' }}
				/>
				<Typography
					data-testid="welcome_tag"
					variant={TypographyVariants.mediumPlusSemiBold}
					sx={{
						mx: 'auto',
						textAlign: 'center',
						mb: 4,
						mt: 4,
					}}
				>
					{Strings.WELCOME_TO_BOSS}
				</Typography>
				<Button variant="bespoke" size="large" onClick={signin}>
					{Strings.WELCOME_GET_STARTED}
				</Button>
			</Box>
		</Grid>
	)
}
